import React, { useState } from "react";
import { StyledDashboard } from "./style";

export const Dashboard = ({ statisticData, operationTime }) => {
  const [dashboardKey, setDashboardKey] = useState("monthlyAverage");
  const [viewText, setViewText] = useState("월 평균");

  const placeString = (str) => {
    if (str === null || str === undefined) return "0";
    return str.toLocaleString("ko-KR");
  };

  const placeTimeString = (str) => {
    if (str === null || str === undefined || str?.includes("NaN"))
      return "0시간 0분 0초";
    return str;
  };

  const DEFAULT_OPERATION_TIME = [
    {
      dailyAverageOperationTime: "-",
      departmentSeq: "기관을 선택하세요.",
      deviceId: "-",
      monthlyAverageOperationTime: "-",
      totalOperationTime: "-",
    },
    {
      dailyAverageOperationTime: "-",
      departmentSeq: "기관을 선택하세요.",
      deviceId: "-",
      monthlyAverageOperationTime: "-",
      totalOperationTime: "-",
    },
  ];
  return (
    <StyledDashboard>
      <div className="dashboard-container">
        <div className="button-wrap">
          <button
            className={dashboardKey === "monthlyAverage" ? "active" : ""}
            onClick={() => {
              setDashboardKey("monthlyAverage");
              setViewText("월 평균");
            }}
          >
            월 평균 조회
          </button>
          <button
            className={dashboardKey === "total" ? "active" : ""}
            onClick={() => {
              setDashboardKey("total");
              setViewText("누적");
            }}
          >
            누적 조회
          </button>
        </div>
        <div className="content-wrap">
          <div className="wrap top">
            <div className="box">
              <div className="part operation">
                <p className="label">
                  {viewText}
                  <br />
                  순회 횟수
                </p>
                <p className="value">
                  {placeString(statisticData?.[`${dashboardKey}OperationCnt`])}
                  건
                </p>
              </div>
              <div className="part receive">
                <p className="label">
                  {viewText}
                  <br />
                  수신데이터 현황
                </p>
                <p className="value">
                  {placeString(
                    statisticData?.[`${dashboardKey}ReceivedDataCnt`]
                  )}
                  건
                </p>
              </div>
            </div>
            <span className="line" />
            <div className="box">
              <div className="part inspected">
                <p className="label">
                  {viewText}
                  <br />
                  검수 횟수
                </p>
                <p className="value">
                  {placeString(statisticData?.[`${dashboardKey}InspectedCnt`])}
                  건
                </p>
              </div>
              <div className="part detected">
                <p className="label">
                  {viewText}
                  <br />
                  검출 포트홀
                </p>
                <p className="value">
                  {placeString(
                    statisticData?.[`${dashboardKey}DetectedPthCnt`]
                  )}
                  건
                </p>
              </div>
            </div>
          </div>

          <div className="wrap bottom">
            {(operationTime ? operationTime : DEFAULT_OPERATION_TIME).map(
              (operation, index) => (
                <React.Fragment key={index}>
                  <div className="box">
                    <p className="title">{operation.departmentSeq}</p>
                    <div className="inner-wrap">
                      <div className="inner-box">
                        <p className="label">누적 조사 시간</p>
                        <p className="value">
                          {placeTimeString(operation.totalOperationTime)}
                        </p>
                      </div>
                      <div className="inner-box">
                        <p className="label">월 평균 조사 시간</p>
                        <p className="value">
                          {placeTimeString(
                            operation.monthlyAverageOperationTime
                          )}
                        </p>
                      </div>
                      <div className="inner-box">
                        <p className="label">일 평균 조사 시간</p>
                        <p className="value">
                          {placeTimeString(operation.dailyAverageOperationTime)}
                        </p>
                      </div>
                    </div>
                  </div>
                  {index % 2 !== 1 && <span className="line" />}
                </React.Fragment>
              )
            )}
            {/* <span className="line" />
            <div className="box">
              <p className="title">
                {operationTime
                  ? operationTime[1].departmentSeq
                  : "기관을 선택하세요."}
              </p>
              <div className="inner-wrap">
                <div className="inner-box">
                  <p className="label">누적 조사 시간</p>
                  <p className="value">
                    {operationTime ? operationTime[1].totalOperationTime : "-"}
                  </p>
                </div>
                <div className="inner-box">
                  <p className="label">월 평균 조사 시간</p>
                  <p className="value">
                    {operationTime
                      ? operationTime[1].monthlyAverageOperationTime
                      : "-"}
                  </p>
                </div>
                <div className="inner-box">
                  <p className="label">일 평균 조사 시간</p>
                  <p className="value">
                    {operationTime
                      ? operationTime[1].dailyAverageOperationTime
                      : "-"}
                  </p>
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </StyledDashboard>
  );
};
